/** 设备处分查询与人工解封契约，设备身份以App隔离，解封不改变账号状态。 */
import { z } from 'zod';
export const DeviceSanctionQuerySchema = z.object({
  app_id: z.string().uuid().optional(),
  device_id: z.string().min(1).max(64).optional(),
  status: z.enum(['active', 'banned']).optional(),
});
/** 确认版本只原样回传，按契约限制 UTF-8 字节，不从时间戳构造。 */
export const DeviceSanctionRevisionSchema = z
  .string()
  .min(1)
  .max(128)
  .refine((value) => {
    // shared仅含ES标准库；按Unicode码点计UTF-8字节，避免依赖浏览器/Node编码API。
    let bytes = 0;
    for (const character of value) {
      const point = character.codePointAt(0) ?? 0;
      bytes += point <= 0x7f ? 1 : point <= 0x7ff ? 2 : point <= 0xffff ? 3 : 4;
      if (bytes > 128) return false;
    }
    return true;
  }, 'Revision must not exceed 128 bytes');
export const ReleaseDeviceSanctionRequestSchema = z
  .object({
    reason: z.string().trim().min(1).max(500),
    expected_revision: DeviceSanctionRevisionSchema,
  })
  .strict();
export type DeviceSanctionQuery = z.infer<typeof DeviceSanctionQuerySchema>;
export type DeviceSanctionResponse = {
  id: string;
  app_id: string;
  device_id: string;
  status: 'active' | 'banned';
  source: 'manual' | 'risk_control';
  risk_rule_id: string | null;
  reason: string | null;
  sanctioned_at: string | null;
  released_at: string | null;
  updated_by: string | null;
  updated_at: string;
  revision: string;
};
